module.exports = __webpack_public_path__ + "static/media/img-ext.e4bc8a5b.svg";